// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MessageCredits — extra-message top-ups on the per-agent billing page.
   Rendered inside .bbp-page, so it matches the rk- billing design (DM Sans,
   brand purple #5616ea, soft cards). Tokens are hardcoded here so the block
   also looks right if it ever renders outside .bbp-page. */

.mc-credits {
  font-family: "DM Sans", sans-serif;
  color: #18181b;
  margin-top: 36px;
  padding-top: 28px;
  border-top: 1px solid #e2e2e6;
}

.mc-head { margin-bottom: 18px; }
.mc-title {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #18181b;
}
.mc-title svg { color: #5616ea; font-size: 15px; }
.mc-sub {
  margin: 6px 0 0;
  font-size: 13.5px;
  line-height: 1.5;
  color: #63636b;
  max-width: 620px;
}

.mc-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 13px;
  border-radius: 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 13.5px;
}

/* Free / non-paid: the whole section renders but disabled; this explains why. */
.mc-locked-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f1ecff;
  border: 1px solid #d9ccff;
  color: #4a2bb5;
  font-size: 13.5px;
  line-height: 1.45;
}
.mc-locked-banner svg { color: #5616ea; flex: 0 0 auto; }

/* ── Usage meter ── */
.mc-meter {
  background: #fff;
  border: 1px solid #e2e2e6;
  border-radius: 10px;
  padding: 16px 18px;
  margin-bottom: 18px;
}
/* Standalone meter rendered at the top of the billing page, above the toggle,
   followed by a thin grey divider (mc-top-divider). Spacing around the line
   mirrors the bottom section divider (.mc-credits: 36px above the line via
   margin-top, 28px below via padding-top) so both grey lines match exactly. */
.mc-meter-top-block { margin: 4px 0 36px; }
.mc-top-divider { border-top: 1px solid #e2e2e6; margin: 0 0 28px; }
/* Loading placeholder: keeps the meter's footprint and reuses the app's
   standard spinner (.main-loading-spinner, scoped purple in BotBilling.css). */
.mc-meter-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 78px;
}
.mc-meter-top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}
.mc-meter-label { font-size: 13px; font-weight: 600; color: #18181b; }
.mc-meter-count { font-size: 14px; font-weight: 700; font-variant-numeric: tabular-nums; color: #18181b; }
.mc-track {
  margin: 10px 0 8px;
  height: 8px;
  border-radius: 10px;
  background: #efecf9;
  overflow: hidden;
}
.mc-fill {
  height: 100%;
  border-radius: 10px;
  background: #5616ea;
  transition: width 0.5s ease;
}
.mc-fill.near { background: #f59e0b; }
.mc-meter-foot {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  color: #63636b;
  font-variant-numeric: tabular-nums;
}

/* ── Packs ── */
.mc-packs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin-bottom: 22px;
}
.mc-pack {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid #e2e2e6;
  border-radius: 10px;
  background: #fff;
  padding: 18px 14px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
.mc-pack:hover { border-color: #c9c9cf; box-shadow: 0 6px 18px -12px rgba(0, 0, 0, 0.35); }
.mc-pack-credits { font-size: 24px; font-weight: 800; color: #18181b; line-height: 1.1; }
.mc-pack-unit { font-size: 12px; color: #63636b; margin-top: 2px; }
.mc-pack-price { font-size: 17px; font-weight: 700; color: #5616ea; margin: 10px 0 12px; }
.mc-pack-cta {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font: inherit;
  font-size: 13.5px;
  font-weight: 700;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #5616ea;
  background: #5616ea;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease;
}
.mc-pack-cta:hover:not(:disabled) { background: #4a14d6; border-color: #4a14d6; }
.mc-pack-cta:disabled { opacity: 0.6; cursor: default; }

/* Locked (Free plan): looks like a disabled control but stays hoverable so the
   upgrade InfoTooltip fires; the click is a no-op (guarded in JS). The tooltip
   wrapper must fill the card so the full-width Buy button keeps its width. */
.mc-pack .info-tooltip-wrapper { display: block; width: 100%; }
.mc-pack-cta.locked,
.mc-pack-cta.locked:hover,
.mc-btn.locked,
.mc-btn.locked:hover {
  background: #f3f3f5;
  border: 1px solid #e2e2e6;
  color: #9b9b9b;
  cursor: not-allowed;
}

/* ── Auto-reload ── */
.mc-autoreload {
  background: #fff;
  border: 1px solid #e2e2e6;
  border-radius: 10px;
  padding: 18px;
}
.mc-ar-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}
.mc-ar-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14.5px;
  font-weight: 700;
  color: #18181b;
}
.mc-ar-title svg { color: #5616ea; font-size: 13px; }
.mc-ar-desc { margin: 5px 0 0; font-size: 13px; line-height: 1.5; color: #63636b; max-width: 520px; }
.mc-ar-badge {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 10px;
  white-space: nowrap;
}
.mc-ar-badge.on { background: #dcfce7; color: #15803d; }
.mc-ar-badge.warn { background: #fff7ed; color: #c2410c; }
.mc-ar-alert {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  font-size: 13px;
  line-height: 1.45;
}
/* Column layout: the selector + threshold sit in a row, the action button(s)
   render on their own row BELOW them. */
.mc-ar-controls {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  margin-top: 16px;
}
.mc-ar-fields {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 14px;
}
/* MUI TextField/MenuItem are styled in JS via \`sx\` (matched to the Account
   Settings page); only their footprint is set here. White background so the
   outlined field reads cleanly on the tinted auto-reload panel. */
.mc-ar-input { background: #fff; border-radius: 10px; }
.mc-ar-input.mc-ar-input-select { min-width: 240px; }
.mc-ar-input.mc-ar-input-num { width: 180px; }
.mc-ar-actions { display: flex; gap: 8px; align-items: center; }
.mc-btn {
  font: inherit;
  font-size: 13.5px;
  font-weight: 700;
  padding: 9px 16px;
  border-radius: 10px;
  cursor: pointer;
  min-height: 38px;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.mc-btn.primary { border: 1px solid #5616ea; background: #5616ea; color: #fff; }
.mc-btn.primary:hover:not(:disabled) { background: #4a14d6; border-color: #4a14d6; }
.mc-btn.danger { border: 1px solid #e2e2e6; background: #fff; color: #dc2626; }
.mc-btn.danger:hover:not(:disabled) { border-color: #dc2626; background: #fef2f2; }
.mc-btn:disabled { opacity: 0.6; cursor: default; }

@media (max-width: 560px) {
  .mc-ar-controls { align-items: stretch; }
  .mc-ar-fields { flex-direction: column; align-items: stretch; }
  .mc-ar-input, .mc-ar-input.mc-ar-input-select, .mc-ar-input.mc-ar-input-num { min-width: 0; width: 100%; }
  .mc-ar-actions { flex-direction: column; align-items: stretch; }
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageCredits.css"],"names":[],"mappings":"AAAA;;;2DAG2D;;AAE3D;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,WAAW,mBAAmB,EAAE;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,gBAAgB,cAAc,EAAE,eAAe,EAAE;AACjD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA,wBAAwB,cAAc,EAAE,cAAc,EAAE;;AAExD,sBAAsB;AACtB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;8EAG8E;AAC9E,sBAAsB,kBAAkB,EAAE;AAC1C,kBAAkB,6BAA6B,EAAE,gBAAgB,EAAE;AACnE;+EAC+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,kCAAkC,EAAE,cAAc,EAAE;AACzG;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA,gBAAgB,mBAAmB,EAAE;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0DAA0D;AAC5D;AACA,iBAAiB,qBAAqB,EAAE,gDAAgD,EAAE;AAC1F,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACxF,gBAAgB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAClE,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACzF;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;AACA,oCAAoC,mBAAmB,EAAE,qBAAqB,EAAE;AAChF,wBAAwB,YAAY,EAAE,eAAe,EAAE;;AAEvD;;6EAE6E;AAC7E,iCAAiC,cAAc,EAAE,WAAW,EAAE;AAC9D;;;;EAIE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,mBAAmB,cAAc,EAAE,eAAe,EAAE;AACpD,cAAc,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACpG;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;wCACwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;AACA;;kEAEkE;AAClE,eAAe,gBAAgB,EAAE,mBAAmB,EAAE;AACtD,kCAAkC,gBAAgB,EAAE;AACpD,+BAA+B,YAAY,EAAE;AAC7C,iBAAiB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC/D;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4EAA4E;AAC9E;AACA,kBAAkB,yBAAyB,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAC/E,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE;AACnF,iBAAiB,yBAAyB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9E,sCAAsC,qBAAqB,EAAE,mBAAmB,EAAE;AAClF,mBAAmB,YAAY,EAAE,eAAe,EAAE;;AAElD;EACE,kBAAkB,oBAAoB,EAAE;EACxC,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;EAC9D,8EAA8E,YAAY,EAAE,WAAW,EAAE;EACzG,iBAAiB,sBAAsB,EAAE,oBAAoB,EAAE;AACjE","sourcesContent":["/* MessageCredits — extra-message top-ups on the per-agent billing page.\r\n   Rendered inside .bbp-page, so it matches the rk- billing design (DM Sans,\r\n   brand purple #5616ea, soft cards). Tokens are hardcoded here so the block\r\n   also looks right if it ever renders outside .bbp-page. */\r\n\r\n.mc-credits {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  color: #18181b;\r\n  margin-top: 36px;\r\n  padding-top: 28px;\r\n  border-top: 1px solid #e2e2e6;\r\n}\r\n\r\n.mc-head { margin-bottom: 18px; }\r\n.mc-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: #18181b;\r\n}\r\n.mc-title svg { color: #5616ea; font-size: 15px; }\r\n.mc-sub {\r\n  margin: 6px 0 0;\r\n  font-size: 13.5px;\r\n  line-height: 1.5;\r\n  color: #63636b;\r\n  max-width: 620px;\r\n}\r\n\r\n.mc-error {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n  padding: 10px 13px;\r\n  border-radius: 10px;\r\n  background: #fef2f2;\r\n  border: 1px solid #fecaca;\r\n  color: #b91c1c;\r\n  font-size: 13.5px;\r\n}\r\n\r\n/* Free / non-paid: the whole section renders but disabled; this explains why. */\r\n.mc-locked-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 18px;\r\n  padding: 12px 14px;\r\n  border-radius: 10px;\r\n  background: #f1ecff;\r\n  border: 1px solid #d9ccff;\r\n  color: #4a2bb5;\r\n  font-size: 13.5px;\r\n  line-height: 1.45;\r\n}\r\n.mc-locked-banner svg { color: #5616ea; flex: 0 0 auto; }\r\n\r\n/* ── Usage meter ── */\r\n.mc-meter {\r\n  background: #fff;\r\n  border: 1px solid #e2e2e6;\r\n  border-radius: 10px;\r\n  padding: 16px 18px;\r\n  margin-bottom: 18px;\r\n}\r\n/* Standalone meter rendered at the top of the billing page, above the toggle,\r\n   followed by a thin grey divider (mc-top-divider). Spacing around the line\r\n   mirrors the bottom section divider (.mc-credits: 36px above the line via\r\n   margin-top, 28px below via padding-top) so both grey lines match exactly. */\r\n.mc-meter-top-block { margin: 4px 0 36px; }\r\n.mc-top-divider { border-top: 1px solid #e2e2e6; margin: 0 0 28px; }\r\n/* Loading placeholder: keeps the meter's footprint and reuses the app's\r\n   standard spinner (.main-loading-spinner, scoped purple in BotBilling.css). */\r\n.mc-meter-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 78px;\r\n}\r\n.mc-meter-top {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n.mc-meter-label { font-size: 13px; font-weight: 600; color: #18181b; }\r\n.mc-meter-count { font-size: 14px; font-weight: 700; font-variant-numeric: tabular-nums; color: #18181b; }\r\n.mc-track {\r\n  margin: 10px 0 8px;\r\n  height: 8px;\r\n  border-radius: 10px;\r\n  background: #efecf9;\r\n  overflow: hidden;\r\n}\r\n.mc-fill {\r\n  height: 100%;\r\n  border-radius: 10px;\r\n  background: #5616ea;\r\n  transition: width 0.5s ease;\r\n}\r\n.mc-fill.near { background: #f59e0b; }\r\n.mc-meter-foot {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  font-size: 12px;\r\n  color: #63636b;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* ── Packs ── */\r\n.mc-packs {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\r\n  gap: 12px;\r\n  margin-bottom: 22px;\r\n}\r\n.mc-pack {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  border: 1px solid #e2e2e6;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  padding: 18px 14px;\r\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\r\n}\r\n.mc-pack:hover { border-color: #c9c9cf; box-shadow: 0 6px 18px -12px rgba(0, 0, 0, 0.35); }\r\n.mc-pack-credits { font-size: 24px; font-weight: 800; color: #18181b; line-height: 1.1; }\r\n.mc-pack-unit { font-size: 12px; color: #63636b; margin-top: 2px; }\r\n.mc-pack-price { font-size: 17px; font-weight: 700; color: #5616ea; margin: 10px 0 12px; }\r\n.mc-pack-cta {\r\n  width: 100%;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 7px;\r\n  font: inherit;\r\n  font-size: 13.5px;\r\n  font-weight: 700;\r\n  padding: 8px 12px;\r\n  border-radius: 10px;\r\n  border: 1px solid #5616ea;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n.mc-pack-cta:hover:not(:disabled) { background: #4a14d6; border-color: #4a14d6; }\r\n.mc-pack-cta:disabled { opacity: 0.6; cursor: default; }\r\n\r\n/* Locked (Free plan): looks like a disabled control but stays hoverable so the\r\n   upgrade InfoTooltip fires; the click is a no-op (guarded in JS). The tooltip\r\n   wrapper must fill the card so the full-width Buy button keeps its width. */\r\n.mc-pack .info-tooltip-wrapper { display: block; width: 100%; }\r\n.mc-pack-cta.locked,\r\n.mc-pack-cta.locked:hover,\r\n.mc-btn.locked,\r\n.mc-btn.locked:hover {\r\n  background: #f3f3f5;\r\n  border: 1px solid #e2e2e6;\r\n  color: #9b9b9b;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ── Auto-reload ── */\r\n.mc-autoreload {\r\n  background: #fff;\r\n  border: 1px solid #e2e2e6;\r\n  border-radius: 10px;\r\n  padding: 18px;\r\n}\r\n.mc-ar-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 14px;\r\n}\r\n.mc-ar-title {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14.5px;\r\n  font-weight: 700;\r\n  color: #18181b;\r\n}\r\n.mc-ar-title svg { color: #5616ea; font-size: 13px; }\r\n.mc-ar-desc { margin: 5px 0 0; font-size: 13px; line-height: 1.5; color: #63636b; max-width: 520px; }\r\n.mc-ar-badge {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 11.5px;\r\n  font-weight: 700;\r\n  padding: 4px 10px;\r\n  border-radius: 10px;\r\n  white-space: nowrap;\r\n}\r\n.mc-ar-badge.on { background: #dcfce7; color: #15803d; }\r\n.mc-ar-badge.warn { background: #fff7ed; color: #c2410c; }\r\n.mc-ar-alert {\r\n  margin-top: 12px;\r\n  padding: 10px 12px;\r\n  border-radius: 10px;\r\n  background: #fff7ed;\r\n  border: 1px solid #fed7aa;\r\n  color: #9a3412;\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n}\r\n/* Column layout: the selector + threshold sit in a row, the action button(s)\r\n   render on their own row BELOW them. */\r\n.mc-ar-controls {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 14px;\r\n  margin-top: 16px;\r\n}\r\n.mc-ar-fields {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  gap: 14px;\r\n}\r\n/* MUI TextField/MenuItem are styled in JS via `sx` (matched to the Account\r\n   Settings page); only their footprint is set here. White background so the\r\n   outlined field reads cleanly on the tinted auto-reload panel. */\r\n.mc-ar-input { background: #fff; border-radius: 10px; }\r\n.mc-ar-input.mc-ar-input-select { min-width: 240px; }\r\n.mc-ar-input.mc-ar-input-num { width: 180px; }\r\n.mc-ar-actions { display: flex; gap: 8px; align-items: center; }\r\n.mc-btn {\r\n  font: inherit;\r\n  font-size: 13.5px;\r\n  font-weight: 700;\r\n  padding: 9px 16px;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  min-height: 38px;\r\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\r\n}\r\n.mc-btn.primary { border: 1px solid #5616ea; background: #5616ea; color: #fff; }\r\n.mc-btn.primary:hover:not(:disabled) { background: #4a14d6; border-color: #4a14d6; }\r\n.mc-btn.danger { border: 1px solid #e2e2e6; background: #fff; color: #dc2626; }\r\n.mc-btn.danger:hover:not(:disabled) { border-color: #dc2626; background: #fef2f2; }\r\n.mc-btn:disabled { opacity: 0.6; cursor: default; }\r\n\r\n@media (max-width: 560px) {\r\n  .mc-ar-controls { align-items: stretch; }\r\n  .mc-ar-fields { flex-direction: column; align-items: stretch; }\r\n  .mc-ar-input, .mc-ar-input.mc-ar-input-select, .mc-ar-input.mc-ar-input-num { min-width: 0; width: 100%; }\r\n  .mc-ar-actions { flex-direction: column; align-items: stretch; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
